import {
  AudioLines,
  Bot,
  Braces,
  Calendar,
  CalendarClock,
  ChartNoAxesCombined,
  CircleCheck,
  Clock,
  Database,
  Eye,
  FileText,
  Folder,
  Globe,
  Hash,
  History,
  Languages,
  Layers,
  ListChecks,
  ListFilter,
  MessageSquare,
  Phone,
  Radio,
  Shapes,
  SlidersHorizontal,
  Tag,
  Text,
  UserRound,
  Users,
  type LucideIcon,
} from "lucide-react"

const PROPERTY_ICONS: Record<string, LucideIcon> = {
  creator: UserRound,
  "created-by": UserRound,
  reviewer: UserRound,
  assignee: UserRound,
  agent: Bot,
  agents: Bot,
  persona: Users,
  simulator: Bot,
  type: Shapes,
  category: Layers,
  source: Database,
  scope: Database,
  dataset: Database,
  endpoint: Radio,
  visibility: Eye,
  permissions: Eye,
  status: CircleCheck,
  language: Languages,
  timezone: Globe,
  "time-zone": Globe,
  template: FileText,
  "test-set": Folder,
  "test-case": ListChecks,
  expected: ListChecks,
  metadata: Braces,
  tags: Tag,
  tag: Tag,
  schedule: CalendarClock,
  schedules: CalendarClock,
  metrics: ChartNoAxesCombined,
  metric: ChartNoAxesCombined,
  aggregation: SlidersHorizontal,
  channels: Radio,
  match: ListChecks,
  duration: AudioLines,
  cooldown: Clock,
  "recently-used": History,
  phone: Phone,
  prompt: MessageSquare,
  notes: FileText,
  error: MessageSquare,
}

export function FilterPropertyIcon({
  id,
  kind,
}: {
  id: string
  kind?: string
}) {
  const Icon =
    kind === "date"
      ? Calendar
      : (PROPERTY_ICONS[id.toLowerCase().replace(/\s+/g, "-")] ??
        (kind === "number" ? Hash : kind === "text" ? Text : ListFilter))
  return <Icon />
}
